<template>
  <v-alert
    :value="true"
    :type="type"
    :icon="icon"
    :dismissible="dismissible"
    :prominent="prominent"
    class="dismissible-alert"
    :style="alertStyles"
    @input="onInput"
  >
    <slot />
  </v-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useBannerStore } from './bannerStore'

const props = defineProps({
  bannerId: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'info',
  },
  dismissible: {
    type: Boolean,
    default: true,
  },
  prominent: {
    type: Boolean,
    default: true,
  },
  dismissInset: {
    type: Number,
    default: 0,
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['input', 'dismissed'])
const store = useBannerStore()

const icon = computed(() => (props.showIcon ? undefined : false))
const alertStyles = computed(() => ({
  '--dismiss-inset': `${props.dismissInset}px`,
}))

function onInput(isVisible: boolean) {
  emit('input', isVisible)

  if (props.dismissible && !isVisible) {
    store.dismissBanner(props.bannerId)
    emit('dismissed')
  }
}
</script>

<style scoped>
.dismissible-alert::v-deep .v-alert__wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.dismissible-alert::v-deep .v-alert__content {
  flex: 1 1 auto;
  min-width: 0;
}

.dismissible-alert::v-deep .v-alert__dismissible {
  flex: 0 0 auto;
  align-self: center;
  margin: 0 0 0 8px;
  margin-right: var(--dismiss-inset);
}

.dismissible-alert::v-deep .v-alert__icon {
  flex: 0 0 auto;
}

@media (max-width: 600px) {
  .dismissible-alert::v-deep .v-alert__content {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .dismissible-alert::v-deep .v-alert__content > * {
    min-width: 100%;
    width: max-content;
  }
}
</style>
